<template>
  <div class="create-com-size">
    <div class="breadcrumb" style="background: #fff">页码设置</div>
    <div class="order-detail-basic">
      <el-form label-width="130px" :model="addPageVo" :rules="rules" ref="addform" :hide-required-asterisk="true">
        <el-form-item label="页码名称:" prop="pageName">
          <el-input placeholder="" v-model="addPageVo.pageName" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="页码起始页:" prop="startPage">
          <el-input placeholder="" v-model.number="addPageVo.startPage"></el-input>
          <!-- <el-input-number v-model="addPageVo.startPage" style="width:180px"  size="small" :min="1" label="描述文字"></el-input-number> -->
        </el-form-item>
        <el-form-item label="每P页码数:">
          <el-select v-model="addPageVo.pageNumber" @change="change" placeholder="请选择">
            <el-option label="1" :value="1"></el-option>
            <el-option label="2" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="页码参数:">
          <p style="margin-bottom:10px" v-for="(item,index) in addPageVo.detailVoList" :key="index">
            <span>页码{{index+1}}参数: </span>
            <el-input style="width:200px" placeholder="" @input="change1(index)" v-model="addPageVo.detailVoList[index].portraitParam">
              <template slot="prepend" style="width:60px">
                <el-select v-model="addPageVo.detailVoList[index].portrait" style="width:60px;overflow:hidden" placeholder="选择">
                  <el-option label="距上" value="top"></el-option>
                  <el-option label="距下" value="bottom"></el-option>
                </el-select>
              </template>
              <template slot="append">mm</template>
            </el-input>
            <el-input style="width:200px" placeholder="" v-model="addPageVo.detailVoList[index].transverseParam">
              <template slot="prepend">
                <el-select v-model="addPageVo.detailVoList[index].transverse" style="width:60px;overflow:hidden" placeholder="选择">
                  <el-option label="距左" value="left"></el-option>
                  <el-option label="距右" value="right"></el-option>
                </el-select>
              </template>
              <template slot="append">mm</template>
            </el-input>
          </p>
        </el-form-item>
        <el-form-item label="页码样式:" prop="typeId">
          <el-select v-model="addPageVo.typeId" placeholder="请选择" @change="chagneType">
            <el-option v-for="item in styleList" :key="item.id" :label="item.typeName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预览:">
          <span :style="'font-size:'+addPageVo.fontSize+'px'">{{preview}}</span>
        </el-form-item>
        <el-form-item label="字号:" prop="fontSize">
          <el-input v-model.number="addPageVo.fontSize" placeholder="请输入字号"></el-input>
          <!-- <el-input-number v-model="addPageVo.fontSize" :min="1"></el-input-number> -->
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button round type="primary" @click="save">保存</el-button>
    </div>
  </div>
</template>
 <script>
import { pageNumberAdd, getPageNumberTypeList } from '@/api/pms'
export default {
  name: 'create-com-size',
  data () {
    return {
      rules: {
        pageName: [
          { required: true, message: '请输入页码名称', trigger: 'blur' }
        ],
        startPage: [
          { required: true, message: '页码起始页不能为空' },
          { type: 'number', message: '请输入数字' }
        ],
        typeId: [
          { required: true, message: '请选择页码样式', trigger: 'change' }
        ],
        fontSize: [
          { required: true, message: '字号不能为空' },
          { type: 'number', message: '请输入数字' }
        ]
      },
      addPageVo: {
        detailVoList: [
          {
            // id: 0,
            portrait: '',
            portraitParam: '',
            sorting: 0,
            transverse: '',
            transverseParam: ''
          }
        ],
        typeId: '',
        fontSize: 16,
        pageName: '',
        pageNumber: 1,
        startPage: 1
      },
      styleList: [],
      preview: '',
      addLock: false
    }
  },
  created () {
    this.getStyleList()
  },
  methods: {
    chagneType (val) {
      this.preview = this.styleList.filter(item => item.id === val)[0].preview
    },
    getStyleList () {
      getPageNumberTypeList().then(res => {
        if (res.data.success) {
          this.styleList = res.data.data
        }
      })
    },
    change1 (index) {
    },
    change (val) {
      if (val === 2) {
        this.addPageVo.detailVoList.push({
          // id: 0,
          portrait: '',
          portraitParam: '',
          sorting: 1,
          transverse: '',
          transverseParam: ''
        })
      } else if (val === 1) {
        this.addPageVo.detailVoList.pop()
      }
    },
    save () {
      this.$refs.addform.validate(success => {
        if (!success) {
          return
        }
        if (this.addPageVo.pageName === '') {
          this.$message.error('请输入页码名称')
          return
        }
        let lock = false
        let dataLock = false
        this.addPageVo.detailVoList.forEach(item => {
          if (item.portraitParam === '' || item.transverseParam === '' || item.portrait === '' || item.transverse === '') {
            lock = true
          }
          if (!/^-?[0-9]\d*$/g.test(item.transverseParam) || !/^-?[0-9]\d*$/g.test(item.portraitParam)) {
            dataLock = true
          }
        })
        if (lock) {
          this.$message.error('页码参数不全')
          return
        } else if (dataLock) {
          this.$message.error('页码参数为整数')
          return
        }
        if (this.addLock) {
          this.$message.error('正在创建，请稍后')
          return
        }
        this.addLock = true
        pageNumberAdd(this.addPageVo).then(res => {
          this.addLock = false
          if (res.data.success) {
            this.$message.success('创建成功')
            this.$router.go(-1)
          }
        })
      })
    }
  }
}
</script>
 <style scoped lang="less">
@deep: ~">>>";
.create-com-size {
  .spec-mm {
    span {
      margin-right: 10px;
    }
    .el-input {
      width: auto;
      @{deep} .el-input__inner {
        width: 65px;
      }
    }
    @{deep} .el-input-group__append {
      padding: 0 15px;
    }
  }
}
</style>
